/**
 * @file HTTP 请求统一处理
 * @author dafo<huanghoujin@baijiahulian.com>
 */
import axios from 'axios';
import {message} from 'lark';
import {HttpCode} from './constant';

/* eslint-disable no-magic-numbers */
const defaultEnvType = 'local';
const envType = process.env.ENV_TYPE || defaultEnvType;

const baseURL = envType === defaultEnvType ? '' : '';

axios.defaults.withCredentials = true;

const instance = axios.create({
    baseURL,
    timeout: 15000,
    retry: 3,
    retryDelay: 1000,
});

instance.interceptors.request.use(
    config => {
        // get请求设置Content-Type，绕过axios的判断
        if (config.method === 'get') {
            config.data = true;
        }
        if (process.env.ENV_TYPE === 'local') {
            config.url = `/api${config.url}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const success = ({data, config}) => {
// TODO: 增加通用的处理逻辑
// 需要统一返回的 JSON 格式
// 然后可以识别到响应异常，作统一处理，比如弹窗
// 比如增加同样的 request 拦截，显示 loading 状态
// 然后在 response 里隐藏 loading 状态

    // login 接口根据success字段判断
    if (data.success) {
        return data;
    }
    // reset 接口根据code判断
    if ((data.code && data.code !== HttpCode.success)) {
        // 针对返回的异常情况统一处理
        switch (data.code) {
            case HttpCode.serverError:
                message.error(data.msg);
                break;
            case HttpCode.noAuth:
                message.error(data.msg);
                break;
        }
        return Promise.reject(data);
    }
    return data;
};
const failData = {
    code: 500,
    msg: 'timeout',
};

const fail = res => {
    const {config} = res;

    if (!config || !config.retry) {
        return Promise.resolve(failData);
    }

    config.retryCount = (config.retryCount | 0) + 1;
    if (config.retryCount > config.retry) {
        return Promise.resolve(failData);
    }

    return new Promise(resolve => setTimeout(resolve, config.retryDelay)).then(() => instance.request(config));
};

// instance.interceptors.request.use(
//     config => {
//         return config;
//     }
// );

instance.interceptors.response.use(success, fail);

instance.axios = axios;

export default instance;
